import { Subject } from 'rxjs';
import { MessageInterface } from './types/message';

const showMessageSubject = new Subject<MessageInterface>();

export class MessageService {
  public static sendMessage(message: MessageInterface) {
    return showMessageSubject.next(message);
  }

  public static onShowMessage() {
    return showMessageSubject.asObservable();
  }
}
